import React from 'react'
import CoinsTable from "../components/CoinsTable";

const Homepage = () => {
  return (
    <>
      <CoinsTable />
    </>
  );
}

export default Homepage
